/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as GlyphsRouteImport } from './routes/glyphs'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppModuleRouteImport } from './routes/_app/$module'
import { Route as AppDocumentsRouteImport } from './routes/_app/documents'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppAccountingCashRouteImport } from './routes/_app/accounting/cash'
import { Route as AppAccountingContactsRouteImport } from './routes/_app/accounting/contacts'
import { Route as AppAccountingInvoicesRouteImport } from './routes/_app/accounting/invoices'
import { Route as AppAccountingPartnersRouteImport } from './routes/_app/accounting/partners'
import { Route as AppAccountingPeriodRouteImport } from './routes/_app/accounting/period'
import { Route as AppItemsIndexRouteImport } from './routes/_app/items/index'
import { Route as AppItemsItemIdRouteImport } from './routes/_app/items/$itemId'
import { Route as AppStockIndexRouteImport } from './routes/_app/stock/index'
import { Route as AppStockMovementsRouteImport } from './routes/_app/stock/movements'
import { Route as AppImportKindIndexRouteImport } from './routes/_app/import/$kind/index'
import { Route as AppImportKindBatchIdRouteImport } from './routes/_app/import/$kind/$batchId'
import { Route as AppStockCountsIndexRouteImport } from './routes/_app/stock/counts/index'
import { Route as AppStockCountsCountNoRouteImport } from './routes/_app/stock/counts/$countNo'
import { Route as AppStockLotsIndexRouteImport } from './routes/_app/stock/lots/index'
import { Route as AppStockLotsLotNoRouteImport } from './routes/_app/stock/lots/$lotNo'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const GlyphsRoute = GlyphsRouteImport.update({
  id: '/glyphs',
  path: '/glyphs',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppModuleRoute = AppModuleRouteImport.update({
  id: '/$module',
  path: '/$module',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingCashRoute = AppAccountingCashRouteImport.update({
  id: '/accounting/cash',
  path: '/accounting/cash',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingContactsRoute = AppAccountingContactsRouteImport.update({
  id: '/accounting/contacts',
  path: '/accounting/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingInvoicesRoute = AppAccountingInvoicesRouteImport.update({
  id: '/accounting/invoices',
  path: '/accounting/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingPartnersRoute = AppAccountingPartnersRouteImport.update({
  id: '/accounting/partners',
  path: '/accounting/partners',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingPeriodRoute = AppAccountingPeriodRouteImport.update({
  id: '/accounting/period',
  path: '/accounting/period',
  getParentRoute: () => AppRoute,
} as any)
const AppItemsIndexRoute = AppItemsIndexRouteImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => AppRoute,
} as any)
const AppItemsItemIdRoute = AppItemsItemIdRouteImport.update({
  id: '/items/$itemId',
  path: '/items/$itemId',
  getParentRoute: () => AppRoute,
} as any)
const AppStockIndexRoute = AppStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockMovementsRoute = AppStockMovementsRouteImport.update({
  id: '/stock/movements',
  path: '/stock/movements',
  getParentRoute: () => AppRoute,
} as any)
const AppImportKindIndexRoute = AppImportKindIndexRouteImport.update({
  id: '/import/$kind/',
  path: '/import/$kind/',
  getParentRoute: () => AppRoute,
} as any)
const AppImportKindBatchIdRoute = AppImportKindBatchIdRouteImport.update({
  id: '/import/$kind/$batchId',
  path: '/import/$kind/$batchId',
  getParentRoute: () => AppRoute,
} as any)
const AppStockCountsIndexRoute = AppStockCountsIndexRouteImport.update({
  id: '/stock/counts/',
  path: '/stock/counts/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockCountsCountNoRoute = AppStockCountsCountNoRouteImport.update({
  id: '/stock/counts/$countNo',
  path: '/stock/counts/$countNo',
  getParentRoute: () => AppRoute,
} as any)
const AppStockLotsIndexRoute = AppStockLotsIndexRouteImport.update({
  id: '/stock/lots/',
  path: '/stock/lots/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockLotsLotNoRoute = AppStockLotsLotNoRouteImport.update({
  id: '/stock/lots/$lotNo',
  path: '/stock/lots/$lotNo',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/glyphs': typeof GlyphsRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/$module': typeof AppModuleRoute
  '/documents': typeof AppDocumentsRoute
  '/settings': typeof AppSettingsRoute
  '/accounting/cash': typeof AppAccountingCashRoute
  '/accounting/contacts': typeof AppAccountingContactsRoute
  '/accounting/invoices': typeof AppAccountingInvoicesRoute
  '/accounting/partners': typeof AppAccountingPartnersRoute
  '/accounting/period': typeof AppAccountingPeriodRoute
  '/items/$itemId': typeof AppItemsItemIdRoute
  '/stock/movements': typeof AppStockMovementsRoute
  '/items/': typeof AppItemsIndexRoute
  '/stock/': typeof AppStockIndexRoute
  '/import/$kind/$batchId': typeof AppImportKindBatchIdRoute
  '/stock/counts/$countNo': typeof AppStockCountsCountNoRoute
  '/stock/lots/$lotNo': typeof AppStockLotsLotNoRoute
  '/import/$kind/': typeof AppImportKindIndexRoute
  '/stock/counts/': typeof AppStockCountsIndexRoute
  '/stock/lots/': typeof AppStockLotsIndexRoute
}
export interface FileRoutesByTo {
  '/glyphs': typeof GlyphsRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/$module': typeof AppModuleRoute
  '/documents': typeof AppDocumentsRoute
  '/settings': typeof AppSettingsRoute
  '/': typeof AppIndexRoute
  '/accounting/cash': typeof AppAccountingCashRoute
  '/accounting/contacts': typeof AppAccountingContactsRoute
  '/accounting/invoices': typeof AppAccountingInvoicesRoute
  '/accounting/partners': typeof AppAccountingPartnersRoute
  '/accounting/period': typeof AppAccountingPeriodRoute
  '/items/$itemId': typeof AppItemsItemIdRoute
  '/stock/movements': typeof AppStockMovementsRoute
  '/items': typeof AppItemsIndexRoute
  '/stock': typeof AppStockIndexRoute
  '/import/$kind/$batchId': typeof AppImportKindBatchIdRoute
  '/stock/counts/$countNo': typeof AppStockCountsCountNoRoute
  '/stock/lots/$lotNo': typeof AppStockLotsLotNoRoute
  '/import/$kind': typeof AppImportKindIndexRoute
  '/stock/counts': typeof AppStockCountsIndexRoute
  '/stock/lots': typeof AppStockLotsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/glyphs': typeof GlyphsRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/_app/$module': typeof AppModuleRoute
  '/_app/documents': typeof AppDocumentsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accounting/cash': typeof AppAccountingCashRoute
  '/_app/accounting/contacts': typeof AppAccountingContactsRoute
  '/_app/accounting/invoices': typeof AppAccountingInvoicesRoute
  '/_app/accounting/partners': typeof AppAccountingPartnersRoute
  '/_app/accounting/period': typeof AppAccountingPeriodRoute
  '/_app/items/$itemId': typeof AppItemsItemIdRoute
  '/_app/stock/movements': typeof AppStockMovementsRoute
  '/_app/items/': typeof AppItemsIndexRoute
  '/_app/stock/': typeof AppStockIndexRoute
  '/_app/import/$kind/$batchId': typeof AppImportKindBatchIdRoute
  '/_app/stock/counts/$countNo': typeof AppStockCountsCountNoRoute
  '/_app/stock/lots/$lotNo': typeof AppStockLotsLotNoRoute
  '/_app/import/$kind/': typeof AppImportKindIndexRoute
  '/_app/stock/counts/': typeof AppStockCountsIndexRoute
  '/_app/stock/lots/': typeof AppStockLotsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/glyphs'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup'
    | '/$module'
    | '/documents'
    | '/settings'
    | '/accounting/cash'
    | '/accounting/contacts'
    | '/accounting/invoices'
    | '/accounting/partners'
    | '/accounting/period'
    | '/items/$itemId'
    | '/stock/movements'
    | '/items/'
    | '/stock/'
    | '/import/$kind/$batchId'
    | '/stock/counts/$countNo'
    | '/stock/lots/$lotNo'
    | '/import/$kind/'
    | '/stock/counts/'
    | '/stock/lots/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/glyphs'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup'
    | '/$module'
    | '/documents'
    | '/settings'
    | '/'
    | '/accounting/cash'
    | '/accounting/contacts'
    | '/accounting/invoices'
    | '/accounting/partners'
    | '/accounting/period'
    | '/items/$itemId'
    | '/stock/movements'
    | '/items'
    | '/stock'
    | '/import/$kind/$batchId'
    | '/stock/counts/$countNo'
    | '/stock/lots/$lotNo'
    | '/import/$kind'
    | '/stock/counts'
    | '/stock/lots'
  id:
    | '__root__'
    | '/_app'
    | '/glyphs'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/setup'
    | '/_app/$module'
    | '/_app/documents'
    | '/_app/settings'
    | '/_app/'
    | '/_app/accounting/cash'
    | '/_app/accounting/contacts'
    | '/_app/accounting/invoices'
    | '/_app/accounting/partners'
    | '/_app/accounting/period'
    | '/_app/items/$itemId'
    | '/_app/stock/movements'
    | '/_app/items/'
    | '/_app/stock/'
    | '/_app/import/$kind/$batchId'
    | '/_app/stock/counts/$countNo'
    | '/_app/stock/lots/$lotNo'
    | '/_app/import/$kind/'
    | '/_app/stock/counts/'
    | '/_app/stock/lots/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  GlyphsRoute: typeof GlyphsRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupRoute: typeof SetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/glyphs': {
      id: '/glyphs'
      path: '/glyphs'
      fullPath: '/glyphs'
      preLoaderRoute: typeof GlyphsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$module': {
      id: '/_app/$module'
      path: '/$module'
      fullPath: '/$module'
      preLoaderRoute: typeof AppModuleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/cash': {
      id: '/_app/accounting/cash'
      path: '/accounting/cash'
      fullPath: '/accounting/cash'
      preLoaderRoute: typeof AppAccountingCashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/contacts': {
      id: '/_app/accounting/contacts'
      path: '/accounting/contacts'
      fullPath: '/accounting/contacts'
      preLoaderRoute: typeof AppAccountingContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/invoices': {
      id: '/_app/accounting/invoices'
      path: '/accounting/invoices'
      fullPath: '/accounting/invoices'
      preLoaderRoute: typeof AppAccountingInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/partners': {
      id: '/_app/accounting/partners'
      path: '/accounting/partners'
      fullPath: '/accounting/partners'
      preLoaderRoute: typeof AppAccountingPartnersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/period': {
      id: '/_app/accounting/period'
      path: '/accounting/period'
      fullPath: '/accounting/period'
      preLoaderRoute: typeof AppAccountingPeriodRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/items/': {
      id: '/_app/items/'
      path: '/items'
      fullPath: '/items/'
      preLoaderRoute: typeof AppItemsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/items/$itemId': {
      id: '/_app/items/$itemId'
      path: '/items/$itemId'
      fullPath: '/items/$itemId'
      preLoaderRoute: typeof AppItemsItemIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/': {
      id: '/_app/stock/'
      path: '/stock'
      fullPath: '/stock/'
      preLoaderRoute: typeof AppStockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/movements': {
      id: '/_app/stock/movements'
      path: '/stock/movements'
      fullPath: '/stock/movements'
      preLoaderRoute: typeof AppStockMovementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import/$kind/': {
      id: '/_app/import/$kind/'
      path: '/import/$kind'
      fullPath: '/import/$kind/'
      preLoaderRoute: typeof AppImportKindIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import/$kind/$batchId': {
      id: '/_app/import/$kind/$batchId'
      path: '/import/$kind/$batchId'
      fullPath: '/import/$kind/$batchId'
      preLoaderRoute: typeof AppImportKindBatchIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/counts/': {
      id: '/_app/stock/counts/'
      path: '/stock/counts'
      fullPath: '/stock/counts/'
      preLoaderRoute: typeof AppStockCountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/counts/$countNo': {
      id: '/_app/stock/counts/$countNo'
      path: '/stock/counts/$countNo'
      fullPath: '/stock/counts/$countNo'
      preLoaderRoute: typeof AppStockCountsCountNoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/lots/': {
      id: '/_app/stock/lots/'
      path: '/stock/lots'
      fullPath: '/stock/lots/'
      preLoaderRoute: typeof AppStockLotsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/lots/$lotNo': {
      id: '/_app/stock/lots/$lotNo'
      path: '/stock/lots/$lotNo'
      fullPath: '/stock/lots/$lotNo'
      preLoaderRoute: typeof AppStockLotsLotNoRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppModuleRoute: typeof AppModuleRoute
  AppDocumentsRoute: typeof AppDocumentsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountingCashRoute: typeof AppAccountingCashRoute
  AppAccountingContactsRoute: typeof AppAccountingContactsRoute
  AppAccountingInvoicesRoute: typeof AppAccountingInvoicesRoute
  AppAccountingPartnersRoute: typeof AppAccountingPartnersRoute
  AppAccountingPeriodRoute: typeof AppAccountingPeriodRoute
  AppItemsItemIdRoute: typeof AppItemsItemIdRoute
  AppStockMovementsRoute: typeof AppStockMovementsRoute
  AppItemsIndexRoute: typeof AppItemsIndexRoute
  AppStockIndexRoute: typeof AppStockIndexRoute
  AppImportKindBatchIdRoute: typeof AppImportKindBatchIdRoute
  AppStockCountsCountNoRoute: typeof AppStockCountsCountNoRoute
  AppStockLotsLotNoRoute: typeof AppStockLotsLotNoRoute
  AppImportKindIndexRoute: typeof AppImportKindIndexRoute
  AppStockCountsIndexRoute: typeof AppStockCountsIndexRoute
  AppStockLotsIndexRoute: typeof AppStockLotsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppModuleRoute: AppModuleRoute,
  AppDocumentsRoute: AppDocumentsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountingCashRoute: AppAccountingCashRoute,
  AppAccountingContactsRoute: AppAccountingContactsRoute,
  AppAccountingInvoicesRoute: AppAccountingInvoicesRoute,
  AppAccountingPartnersRoute: AppAccountingPartnersRoute,
  AppAccountingPeriodRoute: AppAccountingPeriodRoute,
  AppItemsItemIdRoute: AppItemsItemIdRoute,
  AppStockMovementsRoute: AppStockMovementsRoute,
  AppItemsIndexRoute: AppItemsIndexRoute,
  AppStockIndexRoute: AppStockIndexRoute,
  AppImportKindBatchIdRoute: AppImportKindBatchIdRoute,
  AppStockCountsCountNoRoute: AppStockCountsCountNoRoute,
  AppStockLotsLotNoRoute: AppStockLotsLotNoRoute,
  AppImportKindIndexRoute: AppImportKindIndexRoute,
  AppStockCountsIndexRoute: AppStockCountsIndexRoute,
  AppStockLotsIndexRoute: AppStockLotsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  GlyphsRoute: GlyphsRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupRoute: SetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
